import { Children, cloneElement } from 'react';
import { useRouter } from 'next/router';
import Link, { LinkProps } from 'next/link';
import cn from 'classnames';

interface Props extends LinkProps {
  children: any;
  activeClassName: string;
}

export default function ActiveLink({
  children,
  activeClassName,
  href,
  as,
  ...props
}: Props) {
  const { asPath } = useRouter();
  const child = Children.only(children);
  const childClassName = child.props.className || ``;

  const className =
    asPath === href || asPath === as
      ? cn(childClassName, activeClassName)
      : childClassName;

  return (
    <Link as={as} href={href} {...props} prefetch={false}>
      {cloneElement(child, {
        className: className || null,
      })}
    </Link>
  );
}
